import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NglModule} from 'ng-lightning';
import { GridModule } from '@progress/kendo-angular-grid';

import { RvCreateComponent } from './rv-create.component';
import { WizardModule } from '../../../common/component/wizard/wizard.module';
import { ConfirmDialogModule } from '../../../common/component/confirm-dialog/confirm-dialog.module';
import { SpinnerModule } from '../../../common/component/spinner/spinner.module';
import { AlertModule } from '../../../common/component/alert/alert.module';

import{CalendarModule} from '../../../common/component/calendar/calendar.module';

import { DateTimeModule} from '../../../common/component/date-time/date-time.module';
import { RvService, AddDaysToDate } from '../../../core';

import { IntlModule } from '@progress/kendo-angular-intl';
import { UpdateStateService } from '../../../core';

@NgModule({
  imports: [
    CommonModule
    ,WizardModule
    ,FormsModule
    ,DateInputsModule
    ,DropDownsModule
    ,GridModule
    ,NglModule
    ,ConfirmDialogModule
    ,SpinnerModule
    ,AlertModule
    ,IntlModule
    ,CalendarModule
    ,DateTimeModule
  ],
  declarations: [RvCreateComponent],
  exports: [RvCreateComponent],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ],
  providers: [UpdateStateService]
})
export class RvCreateModule { }
